/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as PackagesIndexRouteImport } from './routes/packages/index'
import { Route as ActivitiesIndexRouteImport } from './routes/activities/index'
import { Route as PackagesIdIndexRouteImport } from './routes/packages/$id/index'
import { Route as ActivitiesIdIndexRouteImport } from './routes/activities/$id/index'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const PackagesIndexRoute = PackagesIndexRouteImport.update({
  id: '/packages/',
  path: '/packages/',
  getParentRoute: () => rootRouteImport,
} as any)
const ActivitiesIndexRoute = ActivitiesIndexRouteImport.update({
  id: '/activities/',
  path: '/activities/',
  getParentRoute: () => rootRouteImport,
} as any)
const PackagesIdIndexRoute = PackagesIdIndexRouteImport.update({
  id: '/packages/$id/',
  path: '/packages/$id/',
  getParentRoute: () => rootRouteImport,
} as any)
const ActivitiesIdIndexRoute = ActivitiesIdIndexRouteImport.update({
  id: '/activities/$id/',
  path: '/activities/$id/',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/activities': typeof ActivitiesIndexRoute
  '/packages': typeof PackagesIndexRoute
  '/activities/$id': typeof ActivitiesIdIndexRoute
  '/packages/$id': typeof PackagesIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/activities': typeof ActivitiesIndexRoute
  '/packages': typeof PackagesIndexRoute
  '/activities/$id': typeof ActivitiesIdIndexRoute
  '/packages/$id': typeof PackagesIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/activities/': typeof ActivitiesIndexRoute
  '/packages/': typeof PackagesIndexRoute
  '/activities/$id/': typeof ActivitiesIdIndexRoute
  '/packages/$id/': typeof PackagesIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/activities'
    | '/packages'
    | '/activities/$id'
    | '/packages/$id'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/activities' | '/packages' | '/activities/$id' | '/packages/$id'
  id:
    | '__root__'
    | '/'
    | '/activities/'
    | '/packages/'
    | '/activities/$id/'
    | '/packages/$id/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ActivitiesIndexRoute: typeof ActivitiesIndexRoute
  PackagesIndexRoute: typeof PackagesIndexRoute
  ActivitiesIdIndexRoute: typeof ActivitiesIdIndexRoute
  PackagesIdIndexRoute: typeof PackagesIdIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/packages/': {
      id: '/packages/'
      path: '/packages'
      fullPath: '/packages'
      preLoaderRoute: typeof PackagesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/activities/': {
      id: '/activities/'
      path: '/activities'
      fullPath: '/activities'
      preLoaderRoute: typeof ActivitiesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/packages/$id/': {
      id: '/packages/$id/'
      path: '/packages/$id'
      fullPath: '/packages/$id'
      preLoaderRoute: typeof PackagesIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/activities/$id/': {
      id: '/activities/$id/'
      path: '/activities/$id'
      fullPath: '/activities/$id'
      preLoaderRoute: typeof ActivitiesIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ActivitiesIndexRoute: ActivitiesIndexRoute,
  PackagesIndexRoute: PackagesIndexRoute,
  ActivitiesIdIndexRoute: ActivitiesIdIndexRoute,
  PackagesIdIndexRoute: PackagesIdIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
